import dayjs from 'dayjs'

export const getDisplayVisitDate = (dateISO?: string | null, isWithoutDay: boolean = false, timeFormat = '') => {
  if (!dateISO)
    return {
      displayDateTime: '',
      altDateTime: '',
    }

  const dateTime = dayjs(dateISO)
  if (!dateTime.isValid())
    return {
      displayDateTime: '',
      altDateTime: '',
    }

  const isThisYear = dayjs().year() === dateTime.year()

  return isWithoutDay
    ? {
        displayDateTime: dateTime.locale('ko').format(isThisYear ? `M.D ${timeFormat}` : `YY.M.D ${timeFormat}`),
        altDateTime: dateTime
          .locale('ko')
          .format(isThisYear ? `M월 DD일 ${timeFormat}` : `YY년 M월 DD일 ${timeFormat}`),
      }
    : {
        displayDateTime: dateTime.locale('ko').format(isThisYear ? `M.D.dd ${timeFormat}` : `YY.M.D.dd ${timeFormat}`),
        altDateTime: dateTime
          .locale('ko')
          .format(isThisYear ? `M월 DD일 dd ${timeFormat}` : `YY년 M월 DD일 dd요일 ${timeFormat}`),
      }
}
